import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export type MemberRole = "owner" | "editor" | "viewer";
export type MemberStatus = "pending" | "active";

export interface ProjectMember {
  id: string;
  project_id: string;
  email: string;
  user_id: string | null;
  name?: string;
  role: MemberRole;
  status: MemberStatus;
  invited_by?: string;
  invited_at?: string;
  accepted_at?: string | null;
}

export async function getMembers(projectId: string): Promise<ProjectMember[]> {
  const { data } = await axios.get(`${BASE}/api/projects/${projectId}/members`);
  return data;
}

export async function inviteMember(
  projectId: string,
  email: string,
  role: "editor" | "viewer"
): Promise<ProjectMember> {
  const { data } = await axios.post(`${BASE}/api/projects/${projectId}/members`, { email, role });
  return data;
}

export async function updateMemberRole(
  projectId: string,
  memberId: string,
  role: "editor" | "viewer"
): Promise<ProjectMember> {
  const { data } = await axios.patch(`${BASE}/api/projects/${projectId}/members/${memberId}`, { role });
  return data;
}

export async function removeMember(projectId: string, memberId: string): Promise<void> {
  await axios.delete(`${BASE}/api/projects/${projectId}/members/${memberId}`);
}
